import React from "react";
import { ShieldCheck } from "lucide-react";

export function Logo({ size = 28, withText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className="relative flex items-center justify-center bg-primary/10 border border-primary/40 p-1.5">
        <ShieldCheck size={size} strokeWidth={1.5} className="text-primary text-glow" />
      </div>
      {withText && (
        <div className="leading-none">
          <div className="font-mono font-bold tracking-tighter text-foreground text-lg">
            PLYX<span className="text-primary">.</span>
          </div>
          <div className="font-mono text-[9px] uppercase tracking-[0.3em] text-muted-foreground">
            Cyber Guard
          </div>
        </div>
      )}
    </div>
  );
}
